import { IAnswer } from '@boldpenguin/sdk';
import { map, pipe } from 'rxjs';

export const containsPrefilledAnswer = () =>
  pipe(
    map((answers: IAnswer[]) =>
      answers.some(
        answer => !!answer.answered_by_source || answer.answered_by_consumer,
      ),
    ),
  );
